export var overrides = function overrides(_ref) {
  var _ref$constants = _ref.constants,
      BUTTON_PADDING_VERTICAL = _ref$constants.BUTTON_PADDING_VERTICAL,
      BUTTON_PADDING_HORIZONTAL = _ref$constants.BUTTON_PADDING_HORIZONTAL,
      BOX_SHADOW = _ref$constants.BOX_SHADOW,
      palette = _ref.palette;
  return {
    MuiListItem: {
      root: {
        '&:last-child': {
          borderBottom: 0
        }
      }
    },
    MuiButton: {
      root: {
        padding: "".concat(BUTTON_PADDING_VERTICAL, "px ").concat(BUTTON_PADDING_HORIZONTAL, "px")
      },
      // Name of the styleSheet
      sizeSmall: {
        padding: "".concat(BUTTON_PADDING_VERTICAL, "px ").concat(BUTTON_PADDING_HORIZONTAL, "px")
      }
    },
    MuiTypography: {
      h4: {
        color: palette.grey.deep
      },
      body1: {
        color: palette.grey.dark
      },
      body2: {
        color: palette.grey.dark
      }
    },
    MuiTabs: {
      root: {
        backgroundColor: palette.common.white
      },
      indicator: {
        backgroundColor: palette.grey.deep
      }
    },
    MuiTab: {
      root: {
        textTransform: 'capitalize'
      },
      textColorPrimary: {
        color: palette.grey.main,
        '&$selected': {
          color: palette.grey.deep
        }
      },
      selected: {}
    },
    MuiPaper: {
      elevation1: {
        boxShadow: BOX_SHADOW
      }
    }
  };
};
export default overrides;